export default __webpack_public_path__ + "static/media/footer_image_2.c6755b5d.jpg";